import React, { useEffect, useState } from "react";
import * as echarts from "echarts";
import { Button, Row, Col, Form, Alert, Modal } from "react-bootstrap";

const DomainChartComponent = ({
  dominios,
  cumplimientos,
  renderClasificacion,
  renderEfectividadCapa,
  renderCumplimientoTooltip,
}) => {
  const [selectedNombrecis, setSelectedNombrecis] = useState(
    dominios.length > 0 ? dominios[0].nombrecis : ""
  );

  const [cumplimientoActivo, setCumplimientoActivo] = useState(0);
  const [efectividadCapa, setEfectividadCapa] = useState(0);
  const [tipoLB, setTipoLB] = useState("");

  const getColorByPercentage = (percentage, isCompensated = false) => {
    percentage = Number(percentage);
    let color = "#F27141";
    if (percentage >= 96) {
      color = "#04BF7B";
    } else if (percentage >= 86) {
      color = "#7DF279";
    } else if (percentage >= 71) {
      color = "#F2BF27";
    }
    if (isCompensated) {
      // Darken color for compensated portion
      const hexToRgb = (hex) => {
        hex = hex.replace("#", "");
        return {
          r: parseInt(hex.substring(0, 2), 16),
          g: parseInt(hex.substring(2, 4), 16),
          b: parseInt(hex.substring(4, 6), 16),
        };
      };
      const { r, g, b } = hexToRgb(color);
      return `rgb(${Math.floor(r * 0.7)}, ${Math.floor(g * 0.7)}, ${Math.floor(
        b * 0.7
      )})`;
    }
    return color;
  };

  useEffect(() => {
    const datosCumplimiento = cumplimientos.find(
      (c) => c.nombrecis === selectedNombrecis
    );

    if (datosCumplimiento) {
      setCumplimientoActivo(datosCumplimiento.porcentaje_cumplimiento);
      setEfectividadCapa(datosCumplimiento.disp_numerico1);

      if (datosCumplimiento.tipo_lb === 'Sistema Operativo') {
        setTipoLB("Aplicaciones");
      }
      if (datosCumplimiento.tipo_lb === 'Base de Datos') {
        setTipoLB("Datos");
      }

    }

    const chartDom = document.getElementById("main");
    const myChart = echarts.init(chartDom);

    const selectedDominios = dominios.find(
      (d) => d.nombrecis === selectedNombrecis
    ).dominios;

    const yAxisData = selectedDominios.map((d) => Object.keys(d)[0]);

    const dataSinCompensar = selectedDominios.map((d) => {
      const val = Object.values(d)[0];
      return Number(val.porcentajeDominio);
    });

    const dataCompensados = selectedDominios.map((d) => {
      const val = Object.values(d)[0];
      const porcentajeDominio = Number(val.porcentajeDominio);
      const porcentajeDominioCompensado = Number(
        val.porcentajeDominioCompensado
      );
      const diferencia = porcentajeDominioCompensado - porcentajeDominio;
      return diferencia > 0 ? diferencia : 0; // aseguramos no graficar valores negativos
    });

    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      legend: {
        top: 10,
        data: [
          { name: "Cumplimiento línea base", icon: "none" },
          { name: "Línea base compensada", icon: "none" },
        ],
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: { type: "value", max: 100 },
      yAxis: { type: "category", data: yAxisData },
      series: [
        {
          name: "Cumplimiento línea base",
          type: "bar",
          stack: "total",
          label: {
            show: true,
            position: "insideRight",
            formatter: "{c}%",
          },
          itemStyle: {
            color: (params) =>
              getColorByPercentage(dataSinCompensar[params.dataIndex], false),
          },
          data: dataSinCompensar,
        },
        {
          name: "Línea base compensada",
          type: "bar",
          stack: "total",
          label: {
            show: true,
            position: "insideRight",
            formatter: "{c}%",
          },
          itemStyle: {
            color: (params) =>
              getColorByPercentage(
                dataSinCompensar[params.dataIndex] +
                  dataCompensados[params.dataIndex],
                true
              ),
          },
          data: dataCompensados,
        },
        {
          name: "Línea de referencia",
          type: "line",
          markLine: {
            symbol: "none",
            lineStyle: { color: "#FF0000", width: 2 },
            data: [{ xAxis: 71 }],
          },
        },
      ],
    };

    myChart.setOption(option);

    return () => {
      myChart.dispose();
    };
  }, [selectedNombrecis, dominios]);

  return (
    <div>
      <Row>
        <Col sm={3}>
          <label>Cumplimiento</label>
          {renderCumplimientoTooltip()}
        </Col>
        <Col sm={2}>
          <input
            disabled
            className="form-control text-center font-weight-bold"
            value={parseFloat(cumplimientoActivo * 100) + "%"}
          />
        </Col>
        <Col sm={3}>
          <label>Efectividad capa {tipoLB}</label>
          {renderEfectividadCapa()}
        </Col>
        <Col sm={2}>
          <input
            disabled
            className="form-control text-center font-weight-bold"
            value={parseFloat(efectividadCapa * 100) + "%"}
          />
        </Col>
      </Row>
      <br />
      <Row className="mt-3">
        <Col sm={12}>
          <h5>Cumplimiento por dominios</h5>
          {renderClasificacion()}
        </Col>
      </Row>
      <select
        onChange={(e) => setSelectedNombrecis(e.target.value)}
        value={selectedNombrecis}
        className="mt-3 form-control"
      >
        {dominios.map((d) => (
          <option key={d.nombrecis} value={d.nombrecis}>
            {d.nombrecis}
          </option>
        ))}
      </select>
      <div id="main" style={{ width: "100%", height: "510px" }}></div>
    </div>
  );
};

export default DomainChartComponent;
